export enum WaitType {
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks'
}

export enum StepType {
  TASK = 'task',
  OUTLOOK = 'outlook',
  GMAIL = 'gmail'
}

export enum CampaignStatus {
  ACTIVE = 'active',
  FAILED = 'failed',
  SUCCESS = 'success'
}
